import { authorizedEdgeFetch } from 'app/axios/edge'
import { authorizedNetworkAiFetch } from 'app/axios/network'
import { RenameDomainParams } from './types'

export interface FetchDomainsParams {
  configs?: string
  depth?: number
  domainid?: string
  homes?: boolean
  jobs?: boolean
  rootdomainid?: string
  tags?: boolean
  uid?: string
  users?: 'direct' | 'inherited' | 'self'
}

export const fetchDomains = (params?: FetchDomainsParams) =>
  authorizedEdgeFetch.get(`/rms/domains`, { params })

export interface FetchDomainParams {
  configs?: boolean
  homes?: boolean
  tags?: boolean
}

export const fetchDomain = (domainId: string, params?: FetchDomainParams) =>
  authorizedEdgeFetch.get(`/rms/domains/${domainId}`, { params })

/**
 available values:
    job_name
    job_updated
    home_name
    software_version
    is_online
    last_contact

The sort order (ASC/DESC) can be requested by adding `.ASC` or `.DESC`
    sort=is_online.DESC

They can also be stacked, delimited with a tilde character ~
    sort=is_online.ASC~software_version.DESC
*/
export interface FetchDomainJobsParams {
  sort?: string
  filter?: string
  page?: number
  count?: number
}

export const fetchDomainJobsWithHome = (
  domainId: string,
  params?: FetchDomainJobsParams
) => authorizedEdgeFetch.get(`/rms/domains/${domainId}/jobs/homes`, { params })

export const fetchDomainJobsWithHomeCount = (
  domainId: string,
  params?: FetchDomainJobsParams
) =>
  authorizedEdgeFetch.get(`/rms/domains/${domainId}/jobs/homes/count`, {
    params,
  })

export const fetchDomainPendingJobs = (
  domainId: string,
  params?: FetchDomainJobsParams
) =>
  authorizedEdgeFetch.get(`/rms/domains/${domainId}/jobs/nohomes`, { params })

export const fetchRenameDomain = (params: RenameDomainParams) =>
  authorizedEdgeFetch.put(`/rms/domains/${params.domainId}`, {
    name: params.name,
  })

export const fetchDeleteDomain = (domainId: string) =>
  authorizedEdgeFetch.delete(`/rms/domains/${domainId}`)

export const fetchDomainDealers = (domainId: string) =>
  authorizedEdgeFetch.get(`rms/domains/${domainId}/dealers`)

export const fetchDomainExport = (domainId: string) =>
  authorizedEdgeFetch.get(`rms/domains/${domainId}/jobs/export`)

export interface FetchMistOrganizationBody {
  domainName: string
}

export const fetchMistOrganization = (
  rootId: string,
  body: FetchMistOrganizationBody
) => authorizedNetworkAiFetch.post(`/domains/${rootId}/orgs`, body)
